import React from "react";
import { Box } from "@mui/material";
import { useAppDispatch } from "src/store/store";
import { setWithdrawalAmount } from "src/store/features/withdrawal.slice";
import InfoIcon from "src/icons/portfolio/InfoIcon";
import { useHistory } from "react-router-dom";

export function ShowInsufficientBalanceComponent({
  available,
  currency,
}: {
  available: number;
  currency?: string;
}) {
  const dispatch = useAppDispatch();
  const handleSetAmount = () => {
    dispatch(setWithdrawalAmount(available));
  };
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        background: "#FFF6F6",
        borderRadius: "16px",
        padding: "8px",
        marginBottom: "28px",
        boxShadow: "none",
      }}>
      <Box component="div" sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <InfoIcon tooltip={""} />
        <Box
          component="div"
          sx={{ fontWeight: 600, color: "#002035", fontSize: 14, paddingLeft: "5px" }}>
          Insufficient balance to withdraw
        </Box>
      </Box>
      <Box component="div" sx={{ color: "#002035", fontWeight: 400, fontSize: 14 }}>
        You only have{" "}
        <Box
          component="span"
          sx={{
            textDecoration: "underline",
            fontWeight: 500,
            cursor: "pointer",
            color: "#002035",
          }}
          onClick={handleSetAmount}>
          {available} {currency}
        </Box>{" "}
        in your available funds.
        <br />
        Please reduce the amount to withdraw.
      </Box>
    </Box>
  );
}

export function ShowMinAmountErrorComponent({ currency }: { currency?: string }) {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        background: "#FFF6F6",
        borderRadius: "16px",
        padding: "8px",
        marginBottom: "28px",
        boxShadow: "none",
      }}>
      <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
        <InfoIcon tooltip={""} />
        <Box
          component="div"
          sx={{ fontWeight: 600, color: "#002035", fontSize: 14, paddingLeft: "5px" }}>
          Withdrawal amount too low
        </Box>
      </Box>
      <Box component="div" sx={{ color: "#002035", fontWeight: 400, fontSize: 14 }}>
        Minimum withdrawal amount is 100 {currency}. Please enter a higher amount to proceed.
      </Box>
    </Box>
  );
}

export function ShowActionRequiredComponent() {
  const history = useHistory();
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        background: "#FEFCF8",
        borderRadius: "16px",
        padding: "8px",
        marginBottom: "28px",
        boxShadow: "none",
      }}>
      <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
        <InfoIcon tooltip={""} />
        <Box
          component="div"
          sx={{ fontWeight: 600, color: "#002035", fontSize: 14, paddingLeft: "5px" }}>
          Action Required
        </Box>
      </Box>
      <Box component="div" sx={{ color: "#002035", fontWeight: 400, fontSize: 14 }}>
        If looks like you don't have 2FA enabled, click{" "}
        <Box
          component="span"
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
            color: "#002035",
          }}
          onClick={() => history.push("/settings/security")}>
          here
        </Box>{" "}
        to continue
      </Box>
    </Box>
  );
}

export function ShowRecentWithdrawalErrorComponent({ dateTime }: { dateTime: string }) {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        background: "#FEFCF8",
        borderRadius: "16px",
        padding: "8px",
        marginBottom: "28px",
        boxShadow: "none",
      }}>
      <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
        <InfoIcon tooltip={""} />
        <Box
          component="div"
          sx={{ fontWeight: 600, color: "#002035", fontSize: 14, paddingLeft: "5px" }}>
          24 Hour withdrawal limit
        </Box>
      </Box>
      <Box component="div" sx={{ color: "#002035", fontWeight: 400, fontSize: 14 }}>
        You can only make one withdrawal every 24 hours. Please try again after your previous
        withdrawal window expires at {dateTime}
      </Box>
    </Box>
  );
}
